<template>
  <div class="_wrapper">

    <!-- Category link block -->
    <div class="dropdown-link" :class="{ 'is-active': isDropdownActive }">
      <router-link class="dropdown-link-title no-underline"
                   :class="{ 'last-category': item.children_data.length === 0 }"
                   :to="categoryLink(item)"
      > {{ item.name }} </router-link>
      <div class="dropdown-link-total"> {{ item.product_count }} </div>
    </div>
    <!---->

    <!-- Category dropdown block -->
    <dropdown-block v-if="item.children_data.length && isDropdownActive" :list="item.children_data" />
    <!---->

  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { mapGetters } from 'vuex'

export default {
  components: {
    DropdownBlock: () => import('theme/components/core/blocks/Shop/Sidebar/Dropdown/DropdownBlock')
  },
  props: {
    // Category data
    item: {
      type: Object
    }
  },
  data () {
    return {
      isDropdownActive: false
    }
  },
  mounted () {
    this.isDropdownActive = this.isCategoryActive
  },
  watch: {
    '$route.path': {
      handler: function () {
        this.isDropdownActive = this.isCategoryActive
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    },

    // Search for substring in the route
    isCategoryActive () {
      return this.$route.path.indexOf(this.item.url_path) !== -1
    }
  },
  methods: {
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    }
  }
}
</script>

<style lang="scss" scoped>
._wrapper {
  margin: 6px 0;

  & .dropdown-link {
    display: flex;
    justify-content: space-between;
    align-items: center;

    transition: .2s;

    &.is-active {
      & .dropdown-link-title {
        color: #f5a623;
      }
    }

    &-title {
      color: #111;
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;

      transition: .2s;

      &:hover {
        cursor: pointer;
        color: #f5a623;
      }

      &.last-category {
        font-weight: 400;
      }
    }

    &-total {
      padding-left: 20px;

      color: #b4b4b4;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }
}
</style>
